const FeedbackService = {
  async saveFeedback(formData) {
    try {
      let url = '/api/performance/feedback';
      let method = 'PUT';
      if (formData.identifier === undefined) {
        const profileLogged = JSON.parse(localStorage.getItem('profile'));
        const { accountIdentifier, identifier } = profileLogged;
        console.log(profileLogged);
        console.log(accountIdentifier);
        formData.profileIdentifier = identifier;
        url = '/api/performance/feedback';
        method = 'POST';
      } else {
        url += '/' + formData.identifier;
      }
      const updatedFormData = {
        ...formData,
        employeeIdentifier: formData.employee.value,
        reviewerIdentifier: formData.reviewer.value,
        dueDate: new Date(formData.dueDate).getTime(),
        status: 'CLOSED'
      };
      delete updatedFormData.employee;
      delete updatedFormData.reviewer;
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedFormData)
      });
      if (response.ok) {
        const newFeedback = await response.json();
        console.log('Feedback has been updated:', newFeedback);
      }
    } catch (error) {
      console.log('Error saving Feedback', error);
    }
  },
  async requestFeedback(formData) {
    try {
      let url = '/api/performance/feedback';
      let method = 'POST';

      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { accountIdentifier, identifier } = profileLogged;
      console.log(profileLogged);
      console.log(accountIdentifier);
      formData.profileIdentifier = identifier;
      url = '/api/performance/feedback';

      const updatedFormData = {
        ...formData,
        employeeIdentifier: formData.employee.value,
        reviewerIdentifier: formData.reviewer.value,
        dueDate: new Date(formData.dueDate).getTime(), 
        status: 'PENDING'
      };
      delete updatedFormData.employee;
      delete updatedFormData.reviewer;
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedFormData)
      });
      if (response.ok) {
        const newFeedback = await response.json();
        console.log('Request has been sent:', newFeedback);
      }
    } catch (error) {
      console.log('Error saving Feedback', error);
    }
  },
  async retrieveAllFeedbackByAccount() {
    try {
      const { identifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(identifier);
      const response = await fetch(
        '/api/performance/feedback/profile/' + identifier
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Feedback', error);
      throw error;
    }
  },
  async retrieveFeedback(identifier) {
    try {
      const response = await fetch('/api/performance/feedback/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Feedback', error);
      throw error;
    }
  },
  async deleteFeedback(identifier) {
    try {
      let url = '/api/performance/feedback/' + identifier;
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(response)
      });
      if (response.ok) {
        const newFeedback = await response.json();
        console.log('Feedback has been deleted:', newFeedback);
      }
    } catch (error) {
      console.log('Error deleting Feedback', error);
    }
  }
};
export default FeedbackService;
